if (!window.__avenoriShellReady) {
  window.__avenoriShellReady = true;

  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        if (detail?.didError) return;

        const itemCount = Array.isArray(detail?.items)
          ? detail.items.reduce((total, item) => total + Number(item.quantity || 0), 0)
          : cart?.totalQuantity;

        if (itemCount == null) return;

        document.querySelectorAll('[data-av-cart-count]').forEach((count) => {
          count.textContent = String(itemCount);
          count.toggleAttribute('hidden', itemCount === 0);
        });
      })
      .catch(() => {});
  });
}
